import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faPlus, faBars, faBookOpen } from "@abodeminehq/parcel-ui/icons/fa/pro-solid";
import {
  Button,
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@abodeminehq/parcel-ui";
import { createFileRoute, useNavigate, Link, Outlet } from '@tanstack/react-router'
import { DocumentMetadata } from '~/lib/schemas'
import { DocumentTree } from '~/components/app/documentation/guides/document-tree'
import { useIsMobile } from '~/hooks/use-mobile'
import { useState, useCallback, useMemo } from 'react'
import { GuideSidebarContext } from '~/contexts/guide-sidebar-context'

export { useGuideSidebarContext } from '~/contexts/guide-sidebar-context'

export const Route = createFileRoute('/docs/guide')({
  component: DocumentsPage,
})

function DocumentsPage() {
  const isMobile = useIsMobile()
  
  const [open, setOpen] = useState(false)
  
  const stableSetOpen = useCallback((newOpen: boolean) => {
    setOpen(newOpen)
  }, [])

  const contextValue = useMemo(() => ({
    open,
    setOpen: stableSetOpen
  }), [open, stableSetOpen])

  // const navigate = useNavigate()

  const documentTree = (
    <DocumentTree
      compact={true}
      openByDefault={true}
      className="h-full"
    />
  )

  return (
    <GuideSidebarContext.Provider value={contextValue}>
      <div className="flex h-screen">
        {/* Desktop File Tree Sidebar */}
        {!isMobile && (
          <div className="w-80 shrink-0">
            {documentTree}
          </div>
        )}

        {/* Mobile Sidebar */}
        {isMobile && (
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetContent side="left" className="w-[300px] p-0">
              <SheetHeader className="px-4 py-4 ">
              
                <SheetClose></SheetClose>
              </SheetHeader>
              <div className="flex-1 overflow-auto">
                {documentTree}
              </div>
            </SheetContent>
          </Sheet>
        )}

        <Outlet />
      </div>
    </GuideSidebarContext.Provider>
  )
}
